import { Component } from '@angular/core';
import { SpinnerSelectors } from '@app/store/spinner/spinner.selectors';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  @Select(SpinnerSelectors.isLoading) isLoading$!: Observable<boolean>;
}
